import { render, staticRenderFns } from "./GlyphShowcasePanelModal.vue?vue&type=template&id=0f672c00&scoped=true&"
import script from "./GlyphShowcasePanelModal.vue?vue&type=script&lang=js&"
export * from "./GlyphShowcasePanelModal.vue?vue&type=script&lang=js&"
import style0 from "./GlyphShowcasePanelModal.vue?vue&type=style&index=0&id=0f672c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f672c00",
  null
  
)

export default component.exports